import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonInput, IonModal } from '@ionic/angular';
import { ColumnMode, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-tanulo',
  templateUrl: './tanulo.component.html',
  styleUrls: ['./tanulo.component.scss'],
})
export class TanuloComponent  implements OnInit {

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly JSON = JSON;

  sajatIntezmeny
  intezmeny=2
  dolgozok=0
  tanulok=0
  felulet=0
  import=0
  besorolas=0
  enaplo=0
  dokumentumok=0
  adatszolg=0
  penzugy=0
  modulok=0
  munkatarssorok=[];
  datetime
  alkalmazk
  alkalmazv

  selected = [];
  /*  A képernyő eddig mockup volt: a szűrő nem szűrt, az „Új" üres űrlapot nyitott,
   *  a Mentés nem hívott semmit, a törlés gombok nem voltak bekötve. A lista mostantól
   *  helyben szűrhető, az űrlap ment (POST /nyilvantartas/tanulo/save), és a törlés is
   *  működik – utóbbi csak akkor, ha a tanulóhoz még nincs jegy/étkezés/záradék. */
  szuro: any = { nev: '', oktazon: '', adid: '' };
  lapMeret = 25;                   // ngx-datatable lapozó (footer) oldalmérete
  osszesTanulo: any[] = [];        // szűretlen lista
  aktivTanulo: any = null;         // épp szerkesztett sor (null = új felvitel)
  mentesFut = false;
  telepules
  allampolgar
  orszag
  SelectionType = SelectionType;
  allomany
  csoport
  @ViewChild("uzenetmodal") modal: IonModal;
  segment="1"
  /** Az Ellenőrző fület megnyitották-e már ennél a tanulónál (addig nem töltünk semmit). */
  ellenorzoNyitva = false;

  portControl: FormControl;
  form: FormGroup;

  constructor(private http: HttpClient,private data: DataService,
    private formBuilder: FormBuilder) {
      this.portControl = this.formBuilder.control(
        {id:142,nev:"magyar"},
        Validators.required
      );
      this.form = this.formBuilder.group({
        anyanyelv: this.portControl,
        allampolgar_1: this.portControl,
        allampolgar_2: this.portControl,
        oktazon: new FormControl(""),
        // A tanulói saját felület belépési azonosítója (IdP-s Microsoft-fiók) + elérhetőség
        adid: new FormControl(""),
        email: new FormControl(""),
        telefon: new FormControl(""),
        adoazon: new FormControl(""),
        viselt_elo: new FormControl(""),
        viselt_vez: new FormControl(""),
        viselt_ker: new FormControl(""),
        szul_elo: new FormControl(""),
        szul_vez: new FormControl(""),
        szul_ker: new FormControl(""),
        anya_elo: new FormControl(""),
        anya_vez: new FormControl(""),
        anya_ker: new FormControl(""),
        szul_datum: new FormControl(""),
        szul_hely: new FormControl({id:undefined,nev:undefined}),
        szul_orszag: new FormControl({id:undefined,nev:undefined}),
        nem: new FormControl(""),
        taj: new FormControl(""),
        all_cim_irsz: new FormControl(""),
        all_cim_telepules: new FormControl(""),
        all_cim_kozter: new FormControl(""),
        all_cim_kozter_jelleg: new FormControl(""),
        all_cim_hsz: new FormControl(""),
        all_cim_pontos: new FormControl(""),
        tart_cim_irsz: new FormControl(""),
        tart_cim_telepules: new FormControl(""),
        tart_cim_kozter:new FormControl(""),
        tart_cim_kozter_jelleg: new FormControl(""),
        tart_cim_hsz: new FormControl(""),
        tart_cim_pontos: new FormControl(""),
        tankot_vege: new FormControl(""),
        tankot_telj: new FormControl(""),
        sni: new FormControl(""),
        btmn: new FormControl(""),
        diakszam: new FormControl(""),
        jogv_statusz:new FormControl(""),
        jogv_kezdete:new FormControl(""),
        jogv_vege:new FormControl(""),
        jogv_varh_vege:new FormControl(""),
        vendeg:new FormControl(""),
        egyeni_tanrend:new FormControl(""),
        ideiglenes_jogv:new FormControl(""),
        intezmeny:new FormControl(""),
        etkezes:new FormControl(""),
        etkezes_helye:new FormControl(""),
        etkezes_laktoz:new FormControl(""),
        etkezes_gluten:new FormControl(""),
        ig_tipus:new FormControl(""),
        ig_szam:new FormControl(""),
      }); 
     }

  async ngOnInit() {
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    this.kotelezoBetolt();
    this.getAllomany();
  }


  getRowClass = (row) => {
    return {
      'row-color-blue': row.priority == 1,
      'row-color-green': row.priority == 2,
      'row-color-orange': row.priority == 3,
      'row-color-red': row.priority == 4,
    };
  }

  /* ── Szűrő ── */
  szures() {
    const norm = (v: any) => String(v || '').toLowerCase().trim();
    const n = norm(this.szuro.nev), o = norm(this.szuro.oktazon), a = norm(this.szuro.adid);
    this.selected = [];
    if (this.tanuloTable) this.tanuloTable.offset = 0;   // szűrés után az első oldalra
    this.allomany = (this.osszesTanulo || []).filter((t: any) => {
      const nev = norm(`${t.viselt_vez || ''} ${t.viselt_ker || ''}`);
      return (!n || nev.includes(n))
        && (!o || norm(t.oktazon).includes(o))
        && (!a || norm(t.adid).includes(a));
    });
  }
  szuresTorles() { this.szuro = { nev: '', oktazon: '', adid: '' }; this.szures(); }

  @ViewChild('tanuloTable') tanuloTable: any;

  /*  KÖTELEZŐ MEZŐK – az adatbázisból (NOT NULL, alapérték nélkül), ahogy a munkatársi
   *  szerkesztőnél. A csillag és a mentés előtti ellenőrzés ugyanebből a listából jön. */
  kotelezoMezok: string[] = [];
  private readonly mezoNevek: Record<string, string> = {
    oktazon: 'Oktatási azonosító', viselt_vez: 'Családi név', viselt_ker: 'Utónév',
    szul_datum: 'Születési idő', nem: 'Nem', intezmeny: 'Intézmény',
    szul_vez: 'Születési családi név', szul_ker: 'Születési utónév', anya_vez: 'Anyja családi név',
    anya_ker: 'Anyja utónév', szul_hely: 'Születési hely', szul_orszag: 'Születési ország',
    allampolgar_1: 'Állampolgárság', allampolgar_2: '2. állampolgárság', taj: 'TAJ',
    all_cim_irsz: 'Állandó cím irányítószám', all_cim_telepules: 'Állandó cím település',
    all_cim_kozter: 'Állandó cím közterület', all_cim_kozter_jelleg: 'Állandó cím közterület jellege',
    all_cim_hsz: 'Állandó cím házszám', tart_cim_irsz: 'Tartózkodási cím irányítószám',
    tart_cim_telepules: 'Tartózkodási cím település', tart_cim_kozter: 'Tartózkodási cím közterület',
    tart_cim_kozter_jelleg: 'Tartózkodási cím közterület jellege', tart_cim_hsz: 'Tartózkodási cím házszám',
  };
  kotelezoBetolt() {
    this.http.get<any>('/api/nyilvantartas/tanulo-required-fields').subscribe({
      next: (r) => { this.kotelezoMezok = Array.isArray(r?.tanulo) ? r.tanulo : []; },
      error: () => { this.kotelezoMezok = []; },
    });
  }
  cs(mezo: string): string {
    return this.kotelezoMezok.includes(mezo) ? ' *' : '';
  }

  /* ── Új tanuló ── */
  ujTanulo() {
    this.aktivTanulo = null;
    //  Új tanulónak még nincs ellenőrzője: a fül el is tűnik.
    this.ellenorzoNyitva = false;
    if (this.segment === '6') this.segment = '1';
    this.form.reset();
    this.form.patchValue({ intezmeny: this.sajatIntezmeny?.intezmenyId, nem: '1' });
    this.modal.present();
  }

  /* ── Mentés (felvitel és módosítás egyaránt) ── */
  confirmTanulo() {
    const raw: any = this.form.getRawValue();
    const ertek = (v: any) => (v && typeof v === 'object' ? (v.nev ?? v.full_name_irsz ?? null) : (v === '' ? null : v));
    const oktazon = String(raw.oktazon || this.aktivTanulo?.oktazon || '').trim();
    if (!oktazon) { this.data.sendToast('Az oktatási azonosító kötelező.', 'error'); return; }
    // Új tanulónál előre megmondjuk, melyik kötelező mező üres – ne a kiszolgáló utasítsa el.
    if (!this.aktivTanulo) {
      const ures = (v: any) => v === null || v === undefined || (typeof v === 'string' && !v.trim());
      const hianyzik = this.kotelezoMezok
        .filter((m) => m !== 'oktazon' && m !== 'intezmeny' && m in raw && ures(raw[m]))
        .map((m) => this.mezoNevek[m] || m);
      if (hianyzik.length) { this.data.sendToast(`Töltsd ki a kötelező mezőket: ${hianyzik.join(', ')}`, 'warning'); return; }
    }

    const tanulo: any = {
      oktazon,
      intezmeny: raw.intezmeny || this.sajatIntezmeny?.intezmenyId,
      viselt_elo: raw.viselt_elo, viselt_vez: raw.viselt_vez, viselt_ker: raw.viselt_ker,
      szul_elo: raw.szul_elo, szul_vez: raw.szul_vez, szul_ker: raw.szul_ker,
      anya_elo: raw.anya_elo, anya_vez: raw.anya_vez, anya_ker: raw.anya_ker,
      szul_datum: raw.szul_datum || null,
      szul_hely: ertek(raw.szul_hely), szul_orszag: ertek(raw.szul_orszag),
      allampolgar_1: ertek(raw.allampolgar_1), allampolgar_2: ertek(raw.allampolgar_2),
      nem: raw.nem, taj: raw.taj, adoazon: raw.adoazon,
      all_cim_irsz: raw.all_cim_irsz, all_cim_telepules: ertek(raw.all_cim_telepules),
      all_cim_kozter: raw.all_cim_kozter, all_cim_kozter_jelleg: raw.all_cim_kozter_jelleg,
      all_cim_hsz: raw.all_cim_hsz, all_cim_pontos: raw.all_cim_pontos,
      tart_cim_irsz: raw.tart_cim_irsz, tart_cim_telepules: ertek(raw.tart_cim_telepules),
      tart_cim_kozter: raw.tart_cim_kozter, tart_cim_kozter_jelleg: raw.tart_cim_kozter_jelleg,
      tart_cim_hsz: raw.tart_cim_hsz, tart_cim_pontos: raw.tart_cim_pontos,
      tankot_vege: raw.tankot_vege || null, tankot_telj: raw.tankot_telj || null,
      sni: raw.sni, btmn: raw.btmn, diakszam: raw.diakszam,
      etkezes: raw.etkezes ? 1 : 0, etkezes_helye: ertek(raw.etkezes_helye) || null,
      adid: raw.adid || null, email: raw.email || null, telefon: raw.telefon || null,
      ig_tipus: raw.ig_tipus, ig_szam: raw.ig_szam,
    };
    const jogviszony: any = {
      oktazon,
      intezmeny: raw.intezmeny || this.sajatIntezmeny?.intezmenyId,
      statusz: raw.jogv_statusz, kezdete: raw.jogv_kezdete || null,
      vege: raw.jogv_vege || null, varh_vege: raw.jogv_varh_vege || null,
      vendeg: raw.vendeg ? 1 : 0, egyeni_tanrend: raw.egyeni_tanrend ? 1 : 0,
      ideiglenes: raw.ideiglenes_jogv ? 1 : 0,
    };

    this.mentesFut = true;
    this.http.post('/api/nyilvantartas/tanulo/save', { tanulo, tanulo_jogviszony: jogviszony }).subscribe({
      next: (r: any) => {
        this.mentesFut = false;
        this.data.sendToast(r?.uj ? 'Új tanuló felvéve.' : 'Tanuló módosítva.', 'success');
        this.modal.dismiss(null, 'confirm');
        this.getAllomany();
      },
      error: (e) => {
        this.mentesFut = false;
        const hiany = (e?.error?.requiredFields?.tanulo || []).map((m: string) => this.mezoNevek[m] || m).join(', ');
        this.data.sendToast(hiany ? `Hiányzó kötelező mező: ${hiany}` : (e?.error?.error || 'Sikertelen mentés'), 'error');
      },
    });
  }

  /* ── Törlés ── */
  tanuloTorol(row: any) {
    const nev = `${row?.viselt_vez || ''} ${row?.viselt_ker || ''}`.trim();
    if (!confirm(`Biztosan törlöd a tanulót?\n\n${nev} (${row?.oktazon})\n\nA törlés csak akkor lehetséges, ha még nincs hozzá jegy, étkezés vagy záradék.`)) return;
    this.http.delete(`/api/nyilvantartas/tanulo/${row.oktazon}`).subscribe({
      next: () => { this.data.sendToast('Tanuló törölve.', 'success'); this.getAllomany(); },
      error: (e) => this.data.sendToast(e?.error?.error || 'A törlés nem sikerült.', 'error'),
    });
  }

  kijeloltekTorlese() {
    if (!this.selected.length) return;
    if (!confirm(`Biztosan törlöd a kijelölt ${this.selected.length} tanulót?`)) return;
    let ok = 0, hiba = 0;
    let hatra = this.selected.length;
    for (const row of [...this.selected]) {
      this.http.delete(`/api/nyilvantartas/tanulo/${row.oktazon}`).subscribe({
        next: () => { ok++; if (!--hatra) this.torlesVege(ok, hiba); },
        error: () => { hiba++; if (!--hatra) this.torlesVege(ok, hiba); },
      });
    }
  }
  private torlesVege(ok: number, hiba: number) {
    this.data.sendToast(`${ok} tanuló törölve${hiba ? `, ${hiba} nem törölhető (van hozzá adat)` : ''}.`, hiba ? 'warning' : 'success');
    this.selected = [];
    this.getAllomany();
  }

  /*  A TANULÓ TANÜGYI ADATAI a „Tanügy” és az „SNI / BTMN” fülhöz – a modal nyitásakor
   *  egyszer, a kiválasztott tanulóra. */
  tanugy: any = null;
  tanugyFut = false;
  tanugyHiba = '';
  ma = moment().format('YYYY-MM-DD');

  private tanugyBetolt(oktazon: any) {
    this.tanugy = null; this.tanugyHiba = '';
    const intezmeny = String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    if (!oktazon || !intezmeny) return;
    this.tanugyFut = true;
    this.http.get<any>(`/api/nyilvantartas/tanulo-tanugy/${encodeURIComponent(String(oktazon))}/${intezmeny}`).subscribe({
      next: (r) => { this.tanugy = r || null; this.tanugyFut = false; },
      error: (e) => { this.tanugyHiba = e?.error?.error || 'A tanügyi adatok most nem tölthetők be.'; this.tanugyFut = false; },
    });
  }

  /** A jogviszony szüneteltetése (a tanuló nem jelenik meg a névsorokban) – csak admin. */
  jogviszonySzunetel(j: any) {
    const intezmeny = String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    const szunetel = +j.statusz !== 2;
    this.http.post<any>(`/api/nyilvantartas/tanulo-jogviszony-szunetel/${intezmeny}`, { id: j.id, szunetel }).subscribe({
      next: (r) => { j.statusz = r?.statusz; this.data.sendToast(szunetel ? 'A jogviszony szünetel – a tanuló nem jelenik meg a névsorokban.' : 'A szüneteltetés vége.', 'success'); },
      error: (e) => this.data.sendToast(e?.error?.error || 'Nem sikerült.', 'error'),
    });
  }

  felmentesMiAlol(f: any): string {
    const r: string[] = [];
    if (+f?.oralatogatas_aloli) r.push('óralátogatás');
    if (+f?.ertekeles_aloli) r.push('értékelés');
    if (+f?.szovegesen_ertekelheto) r.push('szövegesen értékelhető');
    return r.length ? r.join(', ') : 'kedvezmény';
  }

  sniSzakasz(sb: any, szakasz: string): any[] {
    return (sb?.adatok || []).filter((a: any) => a?.szakasz === szakasz);
  }

  /*  SZAKÉRTŐI VÉLEMÉNYEK (backend/szakertoi-velemeny.js) – a beírási napló 95. § (5) adatai.
   *  `szvKreta`: a KRÉTA-tükörből összeállított vélemény(ek), előtöltéshez. */
  szvLista: any[] = [];
  szvKreta: any[] = [];
  szvFut = false;
  szvMentes = false;
  szvUrlap: any = null;
  /** A kiszolgáló döntése (admin: mindkettő; a tanuló osztályfőnöke: csak írás). */
  szvJog: { iras: boolean; torles: boolean } = { iras: true, torles: true };
  private szvOktazon = '';

  private szvIntezmeny(): string {
    return String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
  }

  private szvBetolt(oktazon: any) {
    this.szvLista = []; this.szvKreta = []; this.szvUrlap = null;
    this.szvOktazon = String(oktazon || '');
    const intezmeny = this.szvIntezmeny();
    if (!this.szvOktazon || !intezmeny) return;
    this.szvFut = true;
    this.http.get<any>(`/api/szakertoi-velemeny/tanulo/${encodeURIComponent(this.szvOktazon)}/${intezmeny}`).subscribe({
      next: (r) => {
        this.szvLista = r?.velemenyek || []; this.szvKreta = r?.kreta || []; this.szvFut = false;
        //  Régebbi kiszolgáló nem küld `jog`-ot – akkor marad a régi viselkedés (minden gomb).
        this.szvJog = r?.jog ? { iras: !!r.jog.iras, torles: !!r.jog.torles } : { iras: true, torles: true };
      },
      error: () => { this.szvFut = false; },
    });
  }

  /** Új vélemény – üresen, vagy a KRÉTA-adatból előtöltve (`forras` = 'kreta'). */
  szvUj(kreta: any = null) {
    this.szvUrlap = kreta
      ? { ...kreta, felulvizsgalat: false, forras: 'kreta' }
      : { tipus: 'SNI', felulvizsgalat: this.szvLista.length > 0, forras: 'sajat' };
  }

  szvSzerkeszt(v: any) {
    this.szvUrlap = { ...v, felulvizsgalat: !!+v.felulvizsgalat };
  }

  szvMent() {
    const u = this.szvUrlap;
    if (!u) return;
    if (!u.bizottsag_nev?.trim() && !u.velemeny_szam?.trim()) {
      this.data.sendToast('Legalább a kiállító bizottság nevét vagy a vélemény számát add meg.', 'warning');
      return;
    }
    const intezmeny = this.szvIntezmeny();
    const keres = u.id
      ? this.http.put<any>(`/api/szakertoi-velemeny/${u.id}/${intezmeny}`, u)
      : this.http.post<any>(`/api/szakertoi-velemeny/${intezmeny}`, { ...u, oktazon: this.szvOktazon });
    this.szvMentes = true;
    keres.subscribe({
      next: () => { this.szvMentes = false; this.data.sendToast('A szakértői vélemény mentve.', 'success'); this.szvBetolt(this.szvOktazon); },
      error: (e) => { this.szvMentes = false; this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error'); },
    });
  }

  szvTorol(v: any) {
    if (!confirm(`Törlöd a(z) ${v.tipus} szakértői véleményt (${v.velemeny_szam || v.bizottsag_nev || ''})?`)) return;
    this.http.delete<any>(`/api/szakertoi-velemeny/${v.id}/${this.szvIntezmeny()}`).subscribe({
      next: () => { this.data.sendToast('Törölve.', 'success'); this.szvBetolt(this.szvOktazon); },
      error: (e) => this.data.sendToast(e?.error?.error || 'A törlés nem sikerült.', 'error'),
    });
  }

  segmentValt(ertek: any) {
    if (String(ertek) === '6') this.ellenorzoNyitva = true;
  }

  initModal(id){
    this.form.reset()
    // Az azonosító a tanulónál az OKTAZON (nem adid), és egyenlőséget kell vizsgálni –
    // a korábbi `it.adid=id` értékadás volt, ezért mindig az első sort nyitotta meg.
    let data = (this.osszesTanulo || []).find((it: any) => it.oktazon == id) || {}
    this.aktivTanulo = data
    //  Az Ellenőrző lustán töltődik: új tanulónál csak akkor indul, ha épp az a fül áll nyitva.
    this.ellenorzoNyitva = this.segment === '6' && !!data?.oktazon
    if (this.segment === '6' && !data?.oktazon) this.segment = '1'
    this.tanugyBetolt(data?.oktazon)
    this.szvBetolt(data?.oktazon)
    const parse = (v: any, alap: any = null) => { try { return v ? JSON.parse(v) : alap; } catch { return alap; } }
    data.szul_hely = parse(data.szul_tel_o, data.szul_hely)
    data.szul_orszag = parse(data.szul_orszag_o, data.szul_orszag)
    data.allampolgar_1 = parse(data.allampolgar_1_o, data.allampolgar_1)
    data.allampolgar_2 = parse(data.allampolgar_2_o, data.allampolgar_2)
    data.anyanyelv = parse(data.allampolgar_1_o, data.allampolgar_1)
    data.szul_datum = data.szul_datum ? moment(data.szul_datum).format("YYYY-MM-DD") : null
    // A jogviszony mezői külön néven jönnek a listából
    data.jogv_statusz = data.statusz; data.jogv_kezdete = data.kezdete ? moment(data.kezdete).format("YYYY-MM-DD") : null
    data.jogv_vege = data.vege ? moment(data.vege).format("YYYY-MM-DD") : null
    data.jogv_varh_vege = data.varh_vege ? moment(data.varh_vege).format("YYYY-MM-DD") : null
    console.log(data)
    //  A KRÉTÁ-ból átvett igazolvány-adatok – csak megjelenítés (a forrásuk a KRÉTA).
    const nap = (v: any) => (v ? moment(v).format('YYYY-MM-DD') : null);
    this.igazolvanyok = {
      diakszam: data.diakszam || null, diakigazolvany_kelte: nap(data.diakigazolvany_kelte),
      igazolvany_tipus: data.igazolvany_tipus || null, igazolvany_szam: data.igazolvany_szam || null,
      meresi_azonosito: data.meresi_azonosito || null,
    };
    this.form.patchValue(data)
    console.log(this.form.value)
    this.modal.present();
  }
  igazolvanyok: any = null;
  get vanIgazolvany(): boolean {
    return !!this.igazolvanyok && Object.values(this.igazolvanyok).some((v) => !!v);
  }
  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  getEletut(){
    this.http
    .get(
      'https://merfoldkovek.oh.gov.hu/api/User/Timeline',
      {
        
      }
    )
    .subscribe({
      next: (response) => {
        //this.allomany = response
        console.log(response)
      },
      error: (error) => {
        console.error('Error fetching data:', error);
/*
{
    "allapot": "NincsMegFeliratkozva",
    "formatumVerzio": 1,
    "generalva": "0001-01-01T00:00:00",
    "adatok": null,
    "adatAllapot": "OsszeallitasAlatt",
    "leiratkozasOka": "Oktazonvaltozas",
    "leiratkozva": null,
    "letrehozva": null,
    "megtekintveUgyintezokent": false,
    "ugyintezoOktazon": null,
    "isSucceeded": true,
    "reasonOfFail": null,
    "muveletAzonosito": "67155014-3c68-47cc-802d-a68aee09ce1c",
    "errorCode": 0,
    "errorCodeString": "0000",
    "time": "2025-01-17T16:35:45.4874766+01:00"
} */
      },
    });
  }

  getAllomany(){
    let headers={
      intezmeny: this.sajatIntezmeny.intezmenyId
    }
    this.http
      .get(
        '/api/nyilvantartas/tanulo/'+this.sajatIntezmeny.intezmenyId,
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response: any) => {
          this.osszesTanulo = Array.isArray(response) ? response : []
          this.szures()
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
      this.http
        .get(
          '/api/nyilvantartas/csoport/'+this.sajatIntezmeny.intezmenyId,
          {
            headers: headers,
          }
        )
        .subscribe({
          next: (response) => {
            this.csoport = response
            console.log(this.csoport)
          },
          error: (error) => {
            console.error('Error fetching data:', error);
  
          },
        });
        this.http
      .get(
        '/api/nyilvantartas/telepules/hu',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.telepules = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
      this.http
      .get(
        '/api/nyilvantartas/allampolgarsag',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allampolgar = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
      this.http
      .get(
        '/api/nyilvantartas/orszagok',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.orszag = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }



  cancel() {
    this.modal.dismiss(null, 'cancel');
  }
  confirm(draft) { this.confirmTanulo(); }

  selectChangedAnyanyelv(e){

  }

}
